import React from 'react';
import ReactDOM from 'react-dom';
import "./rt-style.css";
import "./media-queries.css";
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
